import React from 'react';
import {numberWithCommas} from "./util";
import {SHIP_DATA} from "./model/fixtures";

const MASS_CONSTANT = 500000;
const BASIC_MODIFIERS = [0, 0.05, 0.10, 0.15, 0.20, 0.25];
const ADVANCED_MODIFIERS = [0, 0.02, 0.04, 0.06, 0.08, 0.10];
const EXPERT_MODIFER = [0, 0.02, 0.04, 0.06, 0.08, 0.10];

const STABILIZER_NAMES = [
  "-",
  "Mk3",
  "Mk5",
  "Mk7",
  "Mk9",
  "Basic",
  "Federation Navy",
  "Republic Fleet",
  "Shadow Serpentis",
  "Domination",
  "Synthetic Hull",
];

const STABILIZER_VALUES = [
  0,
  0.173,
  0.179,
  0.185,
  0.191,
  0.197,
  0.203,
  0.203,
  0.209,
  0.209,
  0.215,
];

const RIG_NAMES = [
  "-",
  "Polycarbon Engine Housing I",
  "Polycarbon Engine Housing II",
  "Polycarbon Engine Housing III",
  "Polycarbon Engine Housing IV",
];

const RIG_VALUES = [
  0,
  0.10,
  0.15,
  0.20,
  0.25,
];

const STACKING_PENALTY = [
  1.0,
  0.869,
  0.571,
  0.283,
  0.106,
  0,
  0,
  0,
  0,
];

export default class AlignPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ship: 'Condor',
      basicSkill: 5,
      advancedSkill: 4,
      expertSkill: 0,
      stabilizers: [0, 0, 0, 0, 0],
      stabilizersActive: false,
      rigs: [0, 0, 0],
    }
  }

  render() {
    let shipValue = SHIP_DATA[this.state.ship];
    let baseMass = shipValue[0];
    let baseInertia = shipValue[1];

    let skillModifier = (1 - BASIC_MODIFIERS[this.state.basicSkill]) * (1 - ADVANCED_MODIFIERS[this.state.advancedSkill]) * (1 - EXPERT_MODIFER[this.state.expertSkill]);

    let stabilizerModifier = 1.0;
    let numBonuses = 0;
    this.state.stabilizers.slice().sort((a, b) => b - a).forEach(i => {
      let value = STABILIZER_VALUES[i];
      if (this.state.stabilizersActive) {
        value *= 2.5;
      }
      stabilizerModifier *= (1 - value * STACKING_PENALTY[numBonuses]);
      if (value > 0) {
        numBonuses++;
      }
    });

    let rigModifier = 1.0;
    this.state.rigs.slice().sort((a, b) => b - a).forEach(i => {
      let value = RIG_VALUES[i];
      rigModifier *= (1 - value * STACKING_PENALTY[numBonuses]);
      if (value > 0) {
        numBonuses++;
      }
    });

    let inertia = baseInertia * skillModifier * stabilizerModifier * rigModifier;

    let alignTime = Math.log(2) * baseMass / MASS_CONSTANT * inertia;

    // let options = Object.keys(SHIP_DATA).sort().map(name => {
    //   return {"label": name, "value": name}
    // });

    let text = "";
    if (alignTime < 2) {
      text = "Your ship cannot be locked by a gate camp."
    } else if (alignTime < 4) {
      text = "Your ship could be locked by a fast and lucky gate camp."
    } else {
      text = "Your ship can easily be locked by a gate camp."
    }

    return <div className={"container"}>

      <div className={"alert alert-primary"}>
        <strong>DISCLAIMER:</strong> The formula and recommendations used by this tool are based on rumors, speculation, and
        information from Eve Online. Use at your own risk. The data has been imported from a data dump and has been spot checked but not
        formally confirmed.
      </div>

      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id="">Ship</span>
        </div>
        <select className="form-control" onChange={(evt) => this.setState({ship: evt.target.value})}>
          {Object.keys(SHIP_DATA).sort().map(name =>
              <option key={name} value={name} selected={name === this.state.ship}>{name}</option>
          )}
        </select>
      </div>

      <ul>
        <li>Base mass: {numberWithCommas(baseMass)}</li>
        <li>Base inertia: {baseInertia.toFixed(2)}</li>
      </ul>

      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id="">Ship command skills</span>
        </div>
        <input type="number" value={this.state.basicSkill} max={5} min={0}
               onChange={evt => this.setState({basicSkill: parseInt(evt.target.value)})} className="form-control"/>
        <input type="number" value={this.state.advancedSkill} max={5} min={0}
               onChange={evt => this.setState({advancedSkill: parseInt(evt.target.value)})} className="form-control"/>
        <input type="number" value={this.state.expertSkill} max={5} min={0}
               onChange={evt => this.setState({expertSkill: parseInt(evt.target.value)})} className="form-control"/>
      </div>

      <ul>
        <li>Skill modifier: {skillModifier.toFixed(2)}</li>
      </ul>

      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id="">Inertial stabilizers</span>
        </div>
        {this.state.stabilizers.map((val, i) =>
            <select className="form-control" onChange={(evt) => {
              let newStabilizers = this.state.stabilizers;
              newStabilizers[i] = parseInt(evt.target.value);
              this.setState({stabilizers: newStabilizers});
            }}>
              {STABILIZER_NAMES.map((name, j) =>
                  <option key={j} value={j} selected={val === j}>{name}</option>
              )}
            </select>
        )}
      </div>

      <ul>
        <li>
          <input
              type={"checkbox"}
              checked={this.state.stabilizersActive}
              onChange={(evt) => this.setState({stabilizersActive: evt.target.checked})}
          />
          &nbsp;Stabilizers active
        </li>
        <li>Stabilizer modifier: {stabilizerModifier.toFixed(2)}</li>
      </ul>

      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id="">Rigs</span>
        </div>
        {this.state.rigs.map((val, i) =>
            <select className="form-control" onChange={(evt) => {
              let newRigs = this.state.rigs;
              newRigs[i] = parseInt(evt.target.value);
              this.setState({rigs: newRigs});
            }}>
              {RIG_NAMES.map((name, j) =>
                  <option key={j} value={j} selected={val === j}>{name}</option>
              )}
            </select>
        )}
      </div>

      <ul>
        <li>Rig modifier: {rigModifier.toFixed(2)}</li>
      </ul>
      <ul>
        <li>Effective inertia: {inertia.toFixed(2)}</li>
        <li>Align time: <strong>{alignTime.toFixed(2)} seconds</strong></li>
        <li>{text}</li>
      </ul>

    </div>
  }


}